module.exports = __webpack_public_path__ + "media/images/athletes/1892-38b55b601b52117c8689126e930c89aa.png";